import api from "./config";
import { API_ENDPOINTS } from "../../utils/constants";
const profileApi = {

    Profile: async () => {
      var response = await api.get(API_ENDPOINTS.GET_PROFILE);
      return response.data;
    },
    UpdateProfile: async (data) => {
      var response = await api.put(API_ENDPOINTS.UPDATE_PROFILE, data);
      return response.data;
    },
    ChangePassword: async (data) => {
      var response = await api.put(API_ENDPOINTS.CHANGE_PASSWORD, data);
      return response.data;
    },
    GetCustomer: async () => {
      var response = await api.get(API_ENDPOINTS.GET_CUSTOMER);
      return response.data;
    },
  };
  
  export default profileApi;
  